// awsConfig.js
import AWS from 'aws-sdk'

AWS.config.update({
  region: 'ap-south-1', // Replace with your AWS region (e.g., 'us-east-1')
  accessKeyId: 'AKIAZQ3DTHRSNK7RGVPP',
  secretAccessKey: 'uQonqJcGU+aviRbKASJ/XjZGxiVtlv9Mwy6KAEM4',
})

export default AWS